import { SHStack, SHTypography } from "@components/design-systems";
import { useFeeCalculatorAutoCalculatedField } from "@hooks/useFeeCalculatorAutoCalculatedField";
import { SectionConfigCalculationBadge } from "@models/platform-analysis/entities/steps/fee";
import { useTheme } from "@mui/system";
import { hexToRGBA } from "@utils";
import { memo } from "react";
import { NumericFormat } from "react-number-format";

export const FeeCalculatorAutoCalculatedBadge = memo(
  ({ title, autoCalculateConfig }: SectionConfigCalculationBadge) => {
    const { palette } = useTheme();
    const { calculatedValue } =
      useFeeCalculatorAutoCalculatedField(autoCalculateConfig);

    const value = Math.abs(calculatedValue);
    const showDecimalPlacesForValue = value % 1 !== 0;

    return (
      <SHStack
        direction={"row"}
        justifyContent="space-between"
        alignItems={"center"}
        sx={{
          p: "15px",
          border: `1px solid ${palette.secondary[100]}`,
          backgroundColor: hexToRGBA(palette.secondary[100], 0.25),
        }}
      >
        <SHTypography variant="subtitle1">{title}</SHTypography>
        <SHTypography variant="subtitle1" fontSize={"20px"}>
          {calculatedValue < 0 ? "-" : ""}$
          <NumericFormat
            displayType="text"
            defaultValue={0}
            value={value}
            thousandSeparator=","
            decimalScale={showDecimalPlacesForValue ? 2 : 0}
            fixedDecimalScale={showDecimalPlacesForValue}
          />
        </SHTypography>
      </SHStack>
    );
  },
);
